import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { AuthProvider, useAuth } from './lib/auth';
import { HomePage } from './pages/HomePage';
import { TripPage } from './pages/TripPage';
import { NewTripPage } from './pages/NewTripPage';
import { EditTripPage } from './pages/EditTripPage';
import { LoginPage } from './pages/LoginPage';
import { AdminPage } from './pages/AdminPage';
import { ADMIN_EMAIL, GUEST_EMAIL_SUFFIX } from '@shared/types';

function Header() {
  const { user, signOut } = useAuth();
  const isGuest = user?.email.endsWith(GUEST_EMAIL_SUFFIX) ?? false;

  return (
    <header className="border-b border-ink/8">
      <div className="mx-auto flex max-w-2xl items-center justify-between px-5 py-3">
        <Link to="/" className="flex items-center gap-2 font-display text-[1.125rem] text-ink">
          <svg
            width="22"
            height="22"
            viewBox="0 0 120 120"
            fill="none"
            aria-hidden="true"
            className="shrink-0"
          >
            <g transform="rotate(16 60 64)">
              <rect x="32" y="26" width="56" height="80" rx="12" fill="#E9DCC3" stroke="#1F6F5C" strokeWidth="7" />
              <circle cx="60" cy="42" r="6" fill="#FBFAF8" stroke="#1F6F5C" strokeWidth="6" />
            </g>
          </svg>
          Here's My Trip
        </Link>
        {user &&
          (isGuest ? (
            // A guest signing out would orphan their trips — offer the upgrade
            // instead (signup keeps their user row and everything on it), and
            // a way back in for people who already have an account.
            <span className="flex items-center gap-1">
              <Link to="/login" className="btn-quiet !text-meta text-muted">
                Sign in
              </Link>
              <Link to="/signup" className="btn-quiet !text-meta text-accent">
                Create account
              </Link>
            </span>
          ) : (
            <span className="flex items-center gap-1">
              {user.email === ADMIN_EMAIL && (
                <Link to="/admin" className="btn-quiet !text-meta text-muted">
                  Admin
                </Link>
              )}
              <button onClick={() => void signOut()} className="btn-quiet !text-meta">
                Sign out
              </button>
            </span>
          ))}
      </div>
    </header>
  );
}

function NotFound() {
  return (
    <main className="mx-auto max-w-lg px-5 py-24 text-center">
      <h1 className="font-display text-title text-ink">No trip here</h1>
      <p className="mt-3 font-body text-muted">
        This link may have been revoked, or the trip was deleted.
      </p>
      <Link to="/" className="btn-quiet mt-6 inline-block">
        Go to your trips
      </Link>
    </main>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/t/:slug" element={<TripPage />} />
          <Route path="/trips/new" element={<NewTripPage />} />
          <Route path="/trips/:id/edit" element={<EditTripPage />} />
          <Route path="/login" element={<LoginPage mode="login" />} />
          <Route path="/signup" element={<LoginPage mode="signup" />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
